import type { TransferDetailState } from "@/types";

export const TRANSFER_DETAIL_STATES: TransferDetailState[] = [
  "draft",
  "pending-policy",
  "pending-approval",
  "approved",
  "broadcast-confirmed",
  "reconciled",
  "rejected",
  "failed",
  "outcome-unknown",
];

export function isTransferDetailState(value: string | undefined): value is TransferDetailState {
  return !!value && (TRANSFER_DETAIL_STATES as string[]).includes(value);
}

export function resolveTransferDetailState(
  raw: string | undefined,
  fallback: TransferDetailState,
): TransferDetailState {
  return isTransferDetailState(raw) ? raw : fallback;
}

export const TRANSFER_STATE_LABEL: Record<TransferDetailState, string> = {
  draft: "Draft",
  "pending-policy": "Pending Policy",
  "pending-approval": "Pending Approval",
  approved: "Approved",
  "broadcast-confirmed": "Broadcast Confirmed",
  reconciled: "Reconciled",
  rejected: "Rejected",
  failed: "Failed",
  "outcome-unknown": "Outcome Unknown",
};

/** Wizard step resolver — kept out of the client module so the server page can call it. */
export const TRANSFER_WIZARD_STEPS = [1, 2, 3, 4, 5] as const;
export type TransferWizardStep = (typeof TRANSFER_WIZARD_STEPS)[number];

export function resolveTransferWizardStep(raw: string | undefined): TransferWizardStep {
  const n = Number(raw);
  return (TRANSFER_WIZARD_STEPS as readonly number[]).includes(n) ? (n as TransferWizardStep) : 1;
}
